export  const COLORS = { inactive: '#121621', active: '#FFED76' };
